// extracted by mini-css-extract-plugin
export default {"card":"Card_card__u08Dn"};